import {
  isPresignedUrlExpiredAt,
  PRESIGNED_URL_REFRESH_BUFFER_MS,
} from "./stored-attachment-url-cache.js";

type CachedHeaderImageUrl = {
  url: string;
  expiresAtMs: number;
};

const cache = new Map<string, CachedHeaderImageUrl>();

export function templateHeaderImageUrlCacheKey(
  organizationId: number,
  messageId: string,
): string {
  return `template-header:${organizationId}:${messageId}`;
}

export function readCachedTemplateHeaderImageUrl(
  organizationId: number,
  messageId: string,
  now = Date.now(),
): CachedHeaderImageUrl | null {
  const entry = cache.get(templateHeaderImageUrlCacheKey(organizationId, messageId));
  if (!entry || isPresignedUrlExpiredAt(entry.expiresAtMs, now, PRESIGNED_URL_REFRESH_BUFFER_MS)) {
    return null;
  }
  return entry;
}

export function writeCachedTemplateHeaderImageUrl(
  organizationId: number,
  messageId: string,
  url: string,
  expiresAt: string,
): void {
  const expiresAtMs = Date.parse(expiresAt);
  if (!Number.isFinite(expiresAtMs)) {
    return;
  }
  cache.set(templateHeaderImageUrlCacheKey(organizationId, messageId), {
    url,
    expiresAtMs,
  });
}

export function clearCachedTemplateHeaderImageUrl(
  organizationId: number,
  messageId: string,
): void {
  cache.delete(templateHeaderImageUrlCacheKey(organizationId, messageId));
}
